module.exports = __webpack_public_path__ + "static/media/master.18502719.svg";